import { Common, color } from '@stockbit/ui';
import { LimitedComposeContainer } from '../styled';

const { Text } = Common;

function ComposeLimited() {
  return (
    <LimitedComposeContainer>
      <Text color={color.highgray} height="21px">
        Comments on this post have been limited.
      </Text>
    </LimitedComposeContainer>
  );
}

export default ComposeLimited;
